import { useCallback } from "react";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import gregorian from "react-date-object/calendars/gregorian";
import gregorian_en from "react-date-object/locales/gregorian_en";
import { DateObject } from "react-multi-date-picker";

export const useDate = () => {
  const convertDate = useCallback((date, inputFormat, outputFormat) => {
    const converted_date = new DateObject({
      date: date,
      format: inputFormat.format,
      calendar: inputFormat.calendar,
      locale: inputFormat.lacale,
    });
    return converted_date
      .convert(outputFormat.calendar, outputFormat.locale)
      .format(outputFormat.format);
  }, []);

  const simpleGregorianToPersian = useCallback(
    (date) => {
      return convertDate(
        date,
        { calendar: gregorian, locale: gregorian_en, format: "YYYY-MM-DD" },
        { calendar: persian, locale: gregorian_en, format: "YYYY-MM-DD" }
      );
    },
    [convertDate]
  );

  const simplePersianToGregorian = useCallback(
    (date) => {
      return convertDate(
        date,
        { calendar: persian, locale: persian_fa, format: "YYYY-MM-DD" },
        { calendar: gregorian, locale: gregorian_en, format: "YYYY-MM-DD" }
      );
    },
    [convertDate]
  );

  return {
    persian,
    persian_fa,
    gregorian,
    gregorian_en,
    convertDate,
    simpleGregorianToPersian,
    simplePersianToGregorian,
  };
};
